import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {FileText} from 'lucide-react'

const StickyGeneratorCTA = () => {
  const navigate = useNavigate()
  const location = useLocation()

  // Don't show on homepage
  if (location.pathname === '/') return null

  const handleClick = () => {
    navigate('/')
    // Scroll to generator after navigation
    setTimeout(() => {
      const generator = document.getElementById('invoice-generator')
      generator?.scrollIntoView({ behavior: 'smooth' })
    }, 100)
  }

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-[#047857] hover:bg-[#059669] text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-2 font-semibold transition-all hover:scale-105 z-40"
    >
      <FileText className="w-5 h-5" />
      Create Invoice Now
    </button>
  )
}

export default StickyGeneratorCTA
